import type { SeriesInstanceUid } from '~/domain/dicom/uids';
import { DatasetRow } from '../layout/types';

/** The primary row's notice when it is empty and no primary image is chosen. */
export const NO_PRIMARY_IMAGE_NOTICE_ID = 'primaryRow.noPrimaryImage';

/** The primary row's notice when it does not show the primary image. */
export const PRIMARY_IMAGE_NOT_SHOWN_NOTICE_ID =
    'primaryRow.primaryImageNotShown';

/**
 * The primary row's notice when it shows an image while no primary image is
 * chosen.
 */
export const NO_PRIMARY_IMAGE_NAMED_NOTICE_ID =
    'primaryRow.noPrimaryImageNamed';

/** The message id of a notice the primary row shows. */
export type PrimaryRowNoticeId =
    | typeof NO_PRIMARY_IMAGE_NOTICE_ID
    | typeof PRIMARY_IMAGE_NOT_SHOWN_NOTICE_ID
    | typeof NO_PRIMARY_IMAGE_NAMED_NOTICE_ID;

/**
 * The message id of the notice the primary row shows when it does not show
 * the primary image, or `undefined` when it does. A row that shows an image
 * while no primary image is chosen says that the image is not a primary
 * image. The notice never carries the image's name: the
 * notice is announced as a status, and the name is PHI that only the
 * privacy-masked views show.
 */
export function primaryRowNoticeId(
    row: DatasetRow | undefined,
    primarySeriesUid: SeriesInstanceUid | undefined
): PrimaryRowNoticeId | undefined {
    if (primarySeriesUid === undefined) {
        return row?.dataset
            ? NO_PRIMARY_IMAGE_NAMED_NOTICE_ID
            : NO_PRIMARY_IMAGE_NOTICE_ID;
    }
    if (row?.dataset?.seriesInstanceUid === primarySeriesUid) {
        return undefined;
    }
    return PRIMARY_IMAGE_NOT_SHOWN_NOTICE_ID;
}
